module.exports = __webpack_public_path__ + "resources/img/zoom-ui-customizations-01.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom-ui-customizations-01.png
// module id = 1397
// module chunks = 0